import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  edit: {
    defaultMessage: 'Edit',
    description: 'Button text to edit a section',
    id: '16Qnoy',
  },
  continue: {
    defaultMessage: 'Continue',
    description: 'Button text to continue to the next section',
    id: 'pQqa81',
  },
});
